import { Action, Dispatch } from 'redux'
import { updateEditStateAction } from 'reducks/confirm/actions'

const updateEditState = (isBeingEdited: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(updateEditStateAction(isBeingEdited))
  }
}

export default updateEditState
